<template>
    <div class="orderorder">
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 0 10px; box-sizing: border-box">
            <div style="display: flex; align-items: center">
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg)"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('1')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('2')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px; margin-right: 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('3')"
                />
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('4')"
                />
            </div>
            <div style="float: right">
                <el-dropdown trigger="click" @command="handleCommand" style="margin-right: 10px">
                    <el-button type="primary" :disabled="isAdd || !isedit">
                        {{ $t('common.label') }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1" v-if="perData.allow_print == 1">格式1</el-dropdown-item>
                        <el-dropdown-item command="2" v-if="perData.allow_print == 1">格式2</el-dropdown-item>
                        <el-dropdown-item command="3">{{ $t('common.export') }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    :disabled="isAdd || !isedit"
                    @click="add"
                    v-if="perData.allow_add == 1"
                    >{{ $t('common.add') }}</el-button
                >
                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-edit"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="handelEdit"
                    v-if="perData.allow_edit == 1"
                    >{{ $t('common.edit') }}</el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="delOrder"
                    v-if="perData.allow_dele == 1"
                    >{{ $t('common.delete') }}</el-button
                >
                <el-button type="info" size="mini" @click="goHistory" :disabled="!isedit">{{ $t('common.historyBill') }}</el-button>
                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-printer"
                    v-if="perData.allow_print == 1"
                    :disabled="!isedit || nullBtn"
                    @click="printOut"
                    >{{ $t('common.print') }}</el-button
                >
                <el-button type="primary" size="mini" @click="exportFile" :disabled="!isedit">{{ $t('common.export') }}</el-button>
                <el-button type="primary" :disabled="isAdd || !isedit || nullBtn" plain @click="Check(form.check)">{{
                    form.check == 1 ? $t('common.cancelAudit') : $t('common.audit')
                }}</el-button>
            </div>
        </div>

        <div class="top_col">
            <el-row :gutter="20">
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="grid-content bg-purple">
                        {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                    </div>
                </el-col>
                <el-col :span="2">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditStatus') }}：<span :style="{ color: form.check == 1 ? '' : 'red' }">{{ form.check == 1 ? $t('common.audited') : $t('common.notAudited') }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditTime') }}<span>{{ form.check_date }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="top_cols" style="padding-bottom: 0">
            <el-form :model="form">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-form-item :label="$t('common.billNo') + '：'" label-width="180">
                            <el-input v-model="form.bill_no" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.billDate') + '：'" label-width="180" required>
                            <el-date-picker
                                type="datetime"
                                :disabled="isedit"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期"
                                v-model="form.bill_date"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item :label="$t('common.billType') + '：'" required>
                                <mySelect
                                    v-model="form.billtype_no"
                                    :options="allArr.billtype"
                                    values="billtype_no"
                                    labels="billtype_name"
                                    keys="billtype_no"
                                    :disable="isedit"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.customer') + '：'" label-width="180" required>
                            <mySelectOptimized
                                v-model="form.cust_no"
                                :options="allArr.cust"
                                values="cust_no"
                                labels="cust_name"
                                keys="cust_no"
                                :disable="isedit"
                                @input="selectCust"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.counter') + '：'" label-width="180" required>
                            <mySelect
                                v-model="form.counter_no"
                                :options="allArr.counter"
                                values="counter_no"
                                labels="counter_name"
                                keys="counter_no"
                                :disable="isedit"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.salesman') + '：'" label-width="180">
                            <mySelect
                                v-model="form.salesman_no"
                                :options="allArr.salesman"
                                values="salesman_no"
                                labels="salesman_name"
                                keys="salesman_no"
                                :disable="isedit"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item :label="$t('common.currency') + '：'">
                                <mySelect
                                    v-model="form.currency_no"
                                    :options="allArr.currency"
                                    values="currency_no"
                                    labels="currency_name"
                                    keys="currency_no"
                                    :disable="isedit"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.handler') + '：'" label-width="180">
                            <mySelect
                                v-model="form.staff_no"
                                :options="allArr.staff"
                                values="staff_no"
                                labels="staff_name"
                                keys="staff_no"
                                :disable="isedit"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" v-if="systemSet.isstores == 1">
                        <div class="input_col">
                            <el-form-item :label="$t('common.store') + '：'">
                                <mySelect
                                    v-model="form.store_no"
                                    :options="allArr.store"
                                    values="store_no"
                                    labels="store_name"
                                    keys="store_no"
                                    :disable="isedit"
                                    :clearables="false"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="systemSet.isstores == 1 ? 12 : 16">
                        <el-form-item label-width="200" :label="$t('common.remark') + '：'">
                            <el-input type="textarea" :rows="1" v-model="form.remark" :disabled="isedit"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="table1" @mouseleave="dtlleave">
            <div class="title">
                <p>{{ $t('common.productDetail') }}</p>
                <div>
                    <el-button type="" :disabled="isedit" @click="closingCopy()">复制</el-button>
                    <el-button type="" :disabled="isedit" @click="showImpotDialog = true">导入</el-button>
                    <el-button type="" :disabled="isedit" @click="showImpotDialogCost = true">成本优惠</el-button>
                    <el-button type="" :disabled="isedit" @click="closingPrice(1)">{{ $t('common.allPriceSettlement') }}</el-button>
                    <el-button type="" :disabled="isedit" @click="closingPrice(2)">{{ $t('common.allMaterialSettlement') }}</el-button>
                    <el-button type="" :disabled="isedit" @click="closingPrice(3)">{{ $t('common.sequentialPriceSettlement') }}</el-button>
                    <el-button type="" :disabled="isedit" @click="closingPrice(4)">{{ $t('common.sequentialMaterialSettlement') }}</el-button>
                </div>
            </div>
            <vxe-table
                border
                stripe
                resizable
                keep-source
                align="center"
                ref="xTable1"
                :height="maxHeight"
                show-overflow
                highlight-hover-row
                :loading="loading"
                show-footer-overflow
                :footer-method="footerMethod"
                show-footer
                :keyboard-config="{ isArrow: true, isDel: true, isedit: true }"
                :row-class-name="rowChange"
                :data="form.dtl"
                :mouse-config="{ selected: true }"
                :edit-config="{ trigger: 'click', mode: 'row', icon: 'fa fa', activeMethod: activeRowMethod }"
                @cell-mouseenter="dtlenter"
                :key="refushTable"
                @checkbox-change="checkboxChangeEvent"
                @checkbox-all="checkboxChangeEvent"
                :scroll-y="{ enabled: true, gt: 50 }"
            >
                <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                <vxe-table-column type="seq" field="seq" width="70" title="序号">
                    <template slot="header">
                        <i class="el-icon-setting" @click.stop="isedit ? changeTable(1) : null"></i>
                    </template>
                    <template slot-scope="scoped">
                        <span class="add_" v-if="scoped.$rowIndex == dtlIndex">
                            <i class="el-icon-circle-plus-outline" @click="adddtl"></i>
                            <i class="el-icon-remove-outline" @click="deldtl(scoped)"></i>
                        </span>
                        <span v-if="scoped.$rowIndex != dtlIndex">
                            <i style="font-style: normal">{{ scoped.seq }}</i>
                        </span>
                    </template>
                </vxe-table-column>

                <template v-for="(item, index) in rkKeyList">
                    <vxe-table-column
                        :title="item.column_name"
                        :field="item.field"
                        :width="item.column_width"
                        :key="item.field + index"
                        :edit-render="{
                            name: 'input',
                            attrs: { type: item.column_type },
                            autoselect: true,
                            autofocus: '.vxe-input--inner'
                        }"
                        v-if="
                            item.column_status == 1 &&
                            item.column_type != 'select' &&
                            item.field != 'gold_content' &&
                            item.field != 'silver_content' &&
                            item.field != 'gold_amt' &&
                            item.field != 'silver_amt' &&
                            item.field != 'mainstone_amt' &&
                            item.field != 'mainstone_sale_amt' &&
                            item.field != 'stone1_sale_amt' &&
                            item.field != 'stone2_sale_amt' &&
                            item.field != 'stone3_sale_amt' &&
                            item.field != 'stone4_sale_amt' &&
                            item.field != 'stone5_sale_amt' &&
                            item.field != 'stone_sale_amt' &&
                            item.field != 'stone1_amt' &&
                            item.field != 'stone2_amt' &&
                            item.field != 'stone3_amt' &&
                            item.field != 'stone4_amt' &&
                            item.field != 'stone5_amt' &&
                            item.field != 'stone_amt' &&
                            item.field != 'inamt_wage' &&
                            item.field != 'saleamt_wage' &&
                            item.field != 'inamt' &&
                            item.field != 'inamt_original' &&
                            item.field != 'saleamt'
                        "
                    >
                        <template #header="{ column }" v-if="item.batch == 1">
                            <span>{{ column.title }}</span>
                            <el-dropdown trigger="click" :hide-on-click="flagFalse">
                                <el-button class="batchBtn" type="primary" plain :disabled="isedit" @click="batchclick">批量</el-button>
                                <el-dropdown-menu slot="dropdown" style="padding: 15px">
                                    <el-radio-group v-model="batchOption">
                                        <div style="display: flex">
                                            <div style="margin-right: 10px">
                                                <div style="">
                                                    <el-radio label="1">所有行修改为</el-radio>
                                                </div>
                                                <div style="">
                                                    <el-radio label="2">选中行及以下行修改为</el-radio>
                                                </div>
                                                <div style="">
                                                    <el-radio label="5">选中行修改为</el-radio>
                                                </div>
                                            </div>

                                            <div style="margin-right: 10px">
                                                <div style="">
                                                    <el-radio label="3">所有行加减</el-radio>
                                                </div>
                                                <div style="">
                                                    <el-radio label="4">选中行及以下行加减</el-radio>
                                                </div>
                                                <div style="">
                                                    <el-radio label="6">选中行加减</el-radio>
                                                </div>
                                            </div>
                                        </div>
                                    </el-radio-group>
                                    <div style="padding-top: 5px"></div>
                                    <el-form :inline="true">
                                        <el-form-item label="">
                                            <vxe-input
                                                style="width: 280px"
                                                :type="item.column_type"
                                                v-model="batchSelect"
                                                @blur="batchOperation($event, column.property)"
                                            ></vxe-input>
                                        </el-form-item>
                                    </el-form>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                        <template v-slot:edit="{ row }">
                            <vxe-input
                                type="text"
                                @input="handleInput(row, item.field, item.column_type)"
                                @keydown.native="jumptable($event, row, item.field)"
                                v-model="row[item.field]"
                                @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                            ></vxe-input>
                        </template>
                    </vxe-table-column>

                    <vxe-table-column
                        v-if="item.column_status == 1 && item.column_type == 'select'"
                        :title="item.column_name"
                        :field="item.field"
                        :width="item.column_width"
                        :key="item.field + index"
                        :edit-render="{ autofocus: '.el-input__inner' }"
                    >
                        <template #default="{ row }">
                            <span>{{
                                $selectLable.selectLable(
                                    row[item.field],
                                    allArr[item.field.replace('_no', '')],
                                    item.field,
                                    item.field.replace('_no', '_name')
                                )
                            }}</span>
                        </template>
                        <template v-slot:edit="{ row }">
                            <el-select
                                size="mini"
                                v-model="row[item.field]"
                                ref="stylefocus"
                                filterable
                                default-first-option
                                placeholder="请选择"
                                @change="changeData(row, item.field.replace('_no', ''), 'dtl')"
                                @keydown.native="jumptable($event, row, item.field)"
                            >
                                <el-option
                                    v-for="option in allArr[item.field.replace('_no', '')] || []"
                                    v-if="shouldFilterOptions(item.field) ? option.gold_style_no && option.silver_style_no : true"
                                    :key="option[item.field.replace('_no', '') + '_no']"
                                    :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                        option[item.field.replace('_no', '') + '_name']
                                    }`"
                                    :value="option[item.field.replace('_no', '') + '_no']"
                                    :disabled="option.status == 0"
                                ></el-option>
                            </el-select>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="gold_content"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'gold_content' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countGold(row).toFixed(systemSet.wgt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="silver_content"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'silver_content' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countSilver(row).toFixed(systemSet.wgt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="gold_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'gold_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countGoldAmt(row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="silver_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'silver_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countSilverAmt(row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="mainstone_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'mainstone_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('mainstone_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="mainstone_sale_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'mainstone_sale_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('mainstone_sale_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone1_sale_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone1_sale_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone1_sale_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone2_sale_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone2_sale_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone2_sale_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone3_sale_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone3_sale_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone3_sale_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone4_sale_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone4_sale_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone4_sale_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone5_sale_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone5_sale_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone5_sale_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone_sale_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone_sale_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone_sale_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone1_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone1_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone1_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone2_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone2_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone2_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone3_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone3_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone3_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone4_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone4_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone4_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone5_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone5_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone5_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="inamt_original"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'inamt_original' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countInamtOriginal(row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>

                    <vxe-table-column
                        field="inamt_wage"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'inamt_wage' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countInAmtWage(row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="saleamt_wage"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'saleamt_wage' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countOutAmtWage(row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="inamt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'inamt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countInAmt(row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="saleamt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'saleamt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countOutAmt(row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                </template>

                <template #empty>
                    <span style="color: red">
                        <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                    </span>
                </template>
            </vxe-table>
        </div>
        <div class="table_warpper" @mouseleave="billleave">
            <div class="table2 table1">
                <div class="title">
                    <p>{{ $t('common.accountDetail') }}</p>
                </div>
                <vxe-table
                    height="320"
                    :data="form.bill"
                    ref="billTable"
                    :row-class-name="rowChange"
                    resizable
                    stripe
                    :auto-resize="true"
                    :footer-method="footerMethod1"
                    show-footer
                    footer-row-class-name="footclass"
                    border
                    @cell-mouseenter="billenter"
                    :edit-config="{ trigger: 'click', mode: 'cell', icon: 'fa fa', activeMethod: activeRowMethod }"
                    :mouse-config="{ selected: true }"
                    :keyboard-config="{ isArrow: true, isDel: true, isEnter: true, isTab: true, isedit: true, enterToTab: true }"
                    @edit-closed="editClosedEvent"
                    :scroll-y="{ enabled: true, gt: 50 }"
                >
                    <vxe-table-column type="seq" width="70" align="center">
                        <template slot="header">
                            <i class="el-icon-setting" @click.stop="isedit ? changeTable(2) : null"></i>
                        </template>
                        <template slot-scope="scoped">
                            <span class="add_" v-if="scoped.seq == billIndex">
                                <i class="el-icon-circle-plus-outline" @click="addbill"></i>
                                <i class="el-icon-remove-outline" @click="delbill(scoped)"></i>
                            </span>
                            <span v-if="scoped.seq != billIndex">
                                <i style="font-style: normal">{{ scoped.seq }}</i>
                            </span>
                        </template>
                    </vxe-table-column>

                    <template v-for="(item, index) in zkKeyList">
                        <vxe-table-column
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{
                                name: 'input',
                                attrs: { type: item.column_type },
                                autoselect: true,
                                autofocus: '.vxe-input--inner'
                            }"
                            v-if="
                                item.column_status == 1 &&
                                item.column_type != 'select' &&
                                item.field != 'trans_wgt' &&
                                item.field != 'original_amt' &&
                                item.field != 'amt'
                            "
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    type="text"
                                    @input="handleInput(row, item.field, item.column_type)"
                                    @keydown.native="jumptable($event, row, item.field)"
                                    v-model="row[item.field]"
                                    @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            v-if="item.column_status == 1 && item.column_type == 'select'"
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{ autofocus: '.el-input__inner' }"
                        >
                            <template #default="{ row }">
                                <span>{{
                                    $selectLable.selectLable(
                                        row[item.field],
                                        allArr[item.field.replace('_no', '')],
                                        item.field,
                                        item.field.replace('_no', '_name')
                                    )
                                }}</span>
                            </template>
                            <template v-slot:edit="{ row }">
                                <el-select
                                    size="mini"
                                    v-model="row[item.field]"
                                    ref="stylefocus"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    @change="changeData(row, item.field.replace('_no', ''))"
                                    @keydown.native="jumptable($event, row, item.field)"
                                >
                                    <el-option
                                        v-for="option in allArr[item.field.replace('_no', '')] || []"
                                        :key="option[item.field.replace('_no', '') + '_no']"
                                        :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                            option[item.field.replace('_no', '') + '_name']
                                        }`"
                                        :value="option[item.field.replace('_no', '') + '_no']"
                                        :disabled="option.status == 0"
                                    ></el-option>
                                </el-select>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            title="折足重"
                            field="trans_wgt"
                            v-if="item.field == 'trans_wgt' && item.column_status == 1"
                            :width="item.column_width"
                            :key="item.field + index"
                        >
                            <!-- <template v-slot:edit="{ row }">
                                <vxe-input type="number" v-model="row.trans_wgt" @blur="$vaildator.wgt(row)"></vxe-input>
                            </template> -->
                            <template v-slot="{ row }">
                                <span>{{ countAmount(row).toFixed(systemSet.wgt) }}</span>
                            </template>
                        </vxe-table-column>

                        <vxe-table-column
                            title="折前金额"
                            field="original_amt"
                            v-if="item.field == 'original_amt' && item.column_status == 1"
                            :width="item.column_width"
                            :key="item.field + index"
                        >
                            <template v-slot="{ row }">
                                <span>{{ countMoney2(row).toFixed(systemSet.amt) }}</span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            title="金额"
                            field="amt"
                            v-if="item.field == 'amt' && item.column_status == 1"
                            :width="item.column_width"
                            :key="item.field + index"
                        >
                            <template v-slot="{ row }">
                                <span>{{ countMoney1(row).toFixed(systemSet.amt) }}</span>
                            </template>
                        </vxe-table-column>
                    </template>

                    <template #empty>
                        <span style="color: red">
                            <img src="@/assets/img/dontHave.png" style="width: 200px" />
                        </span>
                    </template>
                </vxe-table>
            </div>
            <div class="table3 table1" @mouseleave="amtleave">
                <div class="title">
                    <p>{{ $t('common.paymentDetail') }}</p>
                </div>
                <vxe-table
                    height="320"
                    :data="form.amt"
                    ref="amtTable"
                    :footer-method="footerMethod2"
                    :row-class-name="rowChange"
                    show-footer
                    resizable
                    stripe
                    :auto-resize="true"
                    border
                    :edit-config="{ trigger: 'click', mode: 'cell', icon: 'fa fa', activeMethod: activeRowMethod }"
                    @cell-mouseenter="amtenter"
                    :mouse-config="{ selected: true }"
                    :keyboard-config="{ isArrow: true, isDel: true, isEnter: true, isTab: true, isedit: true, enterToTab: true }"
                    :scroll-y="{ enabled: true, gt: 50 }"
                >
                    <vxe-table-column type="seq" width="70" align="center">
                        <template slot="header">
                            <i class="el-icon-setting" @click.stop="isedit ? changeTable(3) : null"></i>
                        </template>
                        <template slot-scope="scoped">
                            <span class="add_" v-if="scoped.$rowIndex == amtIndex">
                                <i class="el-icon-circle-plus-outline" @click="addamt"></i>
                                <i class="el-icon-remove-outline" @click="delamt(scoped)"></i>
                            </span>
                            <span v-if="scoped.$rowIndex != amtIndex">
                                <i style="font-style: normal">{{ scoped.seq }}</i>
                            </span>
                        </template>
                    </vxe-table-column>

                    <template v-for="(item, index) in fkKeyList">
                        <vxe-table-column
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{
                                name: 'input',
                                attrs: { type: item.column_type },
                                autoselect: true,
                                autofocus: '.vxe-input--inner'
                            }"
                            v-if="item.column_status == 1 && item.column_type != 'select'"
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    type="text"
                                    @input="handleInput(row, item.field, item.column_type)"
                                    @keydown.native="jumptable($event, row, item.field)"
                                    v-model="row[item.field]"
                                    @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            v-if="item.column_status == 1 && item.column_type == 'select'"
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{ autofocus: '.el-input__inner' }"
                        >
                            <template #default="{ row }">
                                <span>{{
                                    $selectLable.selectLable(
                                        row[item.field],
                                        allArr[item.field.replace('_no', '')],
                                        item.field,
                                        item.field.replace('_no', '_name')
                                    )
                                }}</span>
                            </template>
                            <template v-slot:edit="{ row }">
                                <el-select
                                    size="mini"
                                    v-model="row[item.field]"
                                    ref="stylefocus"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    @change="changeData(row, item.field.replace('_no', ''))"
                                    @keydown.native="jumptable($event, row, item.field)"
                                >
                                    <el-option
                                        v-for="option in allArr[item.field.replace('_no', '')] || []"
                                        :key="option[item.field.replace('_no', '') + '_no']"
                                        :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                            option[item.field.replace('_no', '') + '_name']
                                        }`"
                                        :value="option[item.field.replace('_no', '') + '_no']"
                                        :disabled="option.status == 0"
                                    ></el-option>
                                </el-select>
                            </template> </vxe-table-column
                    ></template>

                    <template #empty>
                        <span style="color: red">
                            <img src="@/assets/img/dontHave.png" style="width: 200px" />
                        </span>
                    </template>
                </vxe-table>
            </div>
        </div>
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item :label="$t('common.totalQty') + '：'">
                        <p>{{ form.sumqty }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.priceSettledQty') + '：'">
                        <p>{{ form.balprc_qty }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.materialSettledQty') + '：'">
                        <p>{{ form.tran_qty }}</p>
                    </el-form-item>
                    <el-form-item label="金料重量：">
                        <p>{{ form.gold_wgt }}</p>
                    </el-form-item>
                    <el-form-item label="银料重量：">
                        <p>{{ form.silver_wgt }}</p>
                    </el-form-item>

                    <el-form-item :label="$t('common.payableAmt') + '：'">
                        <p>{{ form.sumamt }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.unroundedAmt') + '：'">
                        <p>{{ form.sumamt2 }}</p>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item :label="$t('common.totalWeight') + '：'">
                        <p>{{ form.sumwgt }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.priceSettledWeight') + '：'">
                        <p>{{ form.balqty_wgt }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.materialSettledWeight') + '：'">
                        <p>{{ form.tran_wgt }}</p>
                    </el-form-item>
                    <el-form-item label="金料金额：">
                        <p>{{ form.gold_amt }}</p>
                    </el-form-item>
                    <el-form-item label="银料金额：">
                        <p>{{ form.silver_amt }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.paidAmt') + '：'">
                        <p>{{ form.settle_amt }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isedit" @click="refreshData(form.id)" style="width: 73px">{{ $t('common.cancel') }}</el-button>
                <el-button type="primary" :disabled="isedit" size="mini" @click="saveItSub">{{ $t('common.save') }}</el-button>
            </div>
        </div>
        <!-- 导入明细弹窗 -->
        <el-dialog title="导入明细" :visible.sync="showImpotDialog" width="45%" :before-close="handleClose">
            <div class="importDialogCenter">
                <div class="centerItem leftItem" @click="outTem">
                    <i class="el-icon-download avatar-uploader-icon"></i>
                    <p class="itemText">点击下载模板</p>
                </div>
                <div class="centerItem">
                    <!--  action="http://grapi.tbrjy.com/api/importdtl_sepwgt" -->
                    <el-upload
                        class="upload-demo"
                        :on-error="uploadError"
                        :on-success="uploadSuccess"
                        :show-file-list="false"
                        style="width: 100%"
                        :headers="headers"
                        drag
                        :action="this.$baseURL + 'importdtl_goldsilverin'"
                        multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" style="text-align: center" slot="tip">支持拓展名：.xlsx</div>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialog = false">取 消</el-button>
                <el-button type="primary" @click="showImpotDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 打印弹出框 -->
        <el-dialog style="padding: 0 0 20px" :title="$t('common.print')" :visible.sync="printData.isshow" width="60%">
            <el-select v-model="query.model_name" placeholder="请选择模板" filterable clearable @change="selectPrints" style="width: 150px">
                <el-option v-for="(item, index) in pullList.model" :key="index" :label="item.id + '-' + item.name" :value="item.id">
                </el-option>
            </el-select>
            <div v-loading="loading" class="printBox" id="print" ref="print" style="page-break-after: always; padding: 10px">
                <div v-for="(itemBig, index) in printList" style="margin-bottom: 0px" :key="index">
                    <div
                        style="display: flex; align-items: center; justify-content: center; margin-bottom: 5px"
                        v-if="DataDtl.company.is_show == 1"
                    >
                        <p class="company" v-if="systemSet.company" :style="`font-size:${DataDtl.company.font_size}px;`">
                            {{ systemSet.company }}
                        </p>
                    </div>
                    <div v-if="DataDtl.title">
                        <div v-if="DataDtl.title.is_show == 1">
                            <p class="printTitle" :style="`font-size:${DataDtl.title.font_size}px;`">
                                {{ itemBig.mains ? itemBig.mains.billtype_name : '' }}
                            </p>
                        </div>
                    </div>
                    <div v-if="DataDtl.header">
                        <div v-if="DataDtl.header.is_show == 1">
                            <div class="printTop" style="margin: 5px 0 10px; padding-bottom: 5px">
                                <div>
                                    <div v-if="DataDtl.custno.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        客户编号：{{ itemBig.mains ? itemBig.mains.cust_no : '' }}
                                    </div>
                                    <div  v-if="DataDtl.custname.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        客户：{{ itemBig.mains ? itemBig.mains.cust_name : '' }}
                                    </div>
                                    <div v-if="DataDtl.counterno.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        柜台编号：{{itemBig.mains ?  itemBig.mains.counter_no : '' }}
                                    </div>
                                    <div v-if="DataDtl.countername.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        柜台：{{ itemBig.mains ? itemBig.mains.counter_name: ''  }}
                                    </div>
                                    <div v-if="DataDtl.billremark.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        备注：{{ itemBig.mains ? itemBig.mains.remark : '' }}
                                    </div>
                                </div>
                                <div>
                                    <div v-if="DataDtl.billno.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        单据编号：{{ itemBig.mains ? itemBig.mains.bill_no : '' }}
                                    </div>
                                    <div v-if="DataDtl.billdate.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                        单据日期：{{ itemBig.mains ? itemBig.mains.bill_date : '' }}
                                    </div>
<!--                                    <div v-if="DataDtl.printdate.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">-->
<!--                                        打印时间：{{ itemBig.mains.print_time }}-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="itemBig.dtls.length != [] && DataDtl.is_fields1 == 1"
                        :style="`margin-bottom:${DataDtl.table1_bottommargin}px;`"
                    >
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <p class="tableName">
                                <span v-if="DataDtl.table_name1_show == 1">{{ DataDtl.table_name1 }}</span>
                            </p>
                            <p v-if="DataDtl.printdate.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">
                                <label>打印时间：</label>{{ itemBig.mains.print_time }}
                            </p>
                        </div>
                        <table :border="DataDtl.is_fields1_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields1">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.ename && item.ename.trim() !== '' ? item.ename : item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.dtls" :key="index">
                                <template v-for="items in fields1">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.no == 'style_name'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no] : '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-if="DataDtl.table1_total_show == 1">
                                <template v-for="(items, indexs) in fields1">
                                    <template v-if="indexs == 0"
                                        ><td
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            合计
                                        </td></template
                                    >
                                    <template v-else>
                                        <template v-if="items.is_show == 1">
                                            <td
                                                :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                    items.align
                                                };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                                :key="items.seq"
                                            >
                                                {{ itemBig.dtls_total[items.no] || '-' }}
                                            </td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>
                    <div v-if="itemBig.dtlGroupBy && DataDtl.is_fields3 == 1" :style="`margin-bottom:${DataDtl.table3_bottommargin}px;`">
                        <p class="tableName">
                            <span v-if="DataDtl.table_name3_show == 1">{{ DataDtl.table_name3 }}</span>
                        </p>
                        <table :border="DataDtl.is_fields3_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields3">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.ename && item.ename.trim() !== '' ? item.ename : item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.dtlGroupBy" :key="index">
                                <template v-for="items in fields3">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.no == 'style_name'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no] : '-' }}
                                        </td>
                                        <td
                                            v-else-if="items.no == 'bill_mode'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no + '_name'] : '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :key="items.seq"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-if="DataDtl.table3_total_show == 1">
                                <template v-for="(items, indexs) in fields3">
                                    <template v-if="indexs == 0"
                                        ><td
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            合计
                                        </td></template
                                    >
                                    <template v-else>
                                        <template v-if="items.is_show == 1">
                                            <td
                                                :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                    items.align
                                                };border:${DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                                :key="items.seq"
                                            >
                                                {{ itemBig.dtlGroupBy_total[items.no] || '-' }}
                                            </td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>
                    <div
                        v-if="itemBig.bills.length != [] && DataDtl.is_fields2 == 1"
                        :style="`margin-bottom:${DataDtl.table2_bottommargin}px;`"
                    >
                        <p class="tableName">
                            <span v-if="DataDtl.table_name2_show == 1">{{ DataDtl.table_name2 }}</span>
                        </p>
                        <table :border="DataDtl.is_fields2_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields2">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.ename && item.ename.trim() !== '' ? item.ename : item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.bills" :key="index">
                                <template v-for="items in fields2">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.no == 'style_name'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no] : '-' }}
                                        </td>
                                        <td
                                            v-else-if="items.no == 'bill_mode'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no + '_name'] : '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :key="items.seq"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-if="DataDtl.table2_total_show == 1">
                                <template v-for="(items, indexs) in fields2">
                                    <template v-if="indexs == 0"
                                        ><td
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            合计
                                        </td></template
                                    >
                                    <template v-else>
                                        <template v-if="items.is_show == 1">
                                            <td
                                                :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                    items.align
                                                };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                                :key="items.seq"
                                            >
                                                {{ itemBig.bills_total[items.no] || '-' }}
                                            </td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>

                    <div v-if="DataDtl.is_tot">
                        <div v-if="DataDtl.is_tot.is_show == 1">
                            <div class="summoney">
                                <div class="sum1">
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`"
                                        >总计 金额大写 {{ itemBig.mains.money_type }}</span
                                    >
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ itemBig.mains.money_chinese }}</span>
                                </div>
                                <div class="sum1">
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`"
                                        >金额合计&nbsp;&nbsp;&nbsp; {{ itemBig.mains.money_type }}</span
                                    >
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ itemBig.mains.money }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
<!--                    <div v-if="DataDtl.custaccounts_begin">-->
<!--                        <div-->
<!--                            class="sum2"-->
<!--                            v-if="DataDtl.custaccounts_begin.is_show == 1"-->
<!--                            :style="`font-size:${DataDtl.custaccounts_begin.font_size}px;`"-->
<!--                        >-->
<!--                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">期初存欠帐（正欠负存）:</span>-->
<!--                            <div style="display: flex; flex-wrap: wrap; width: 80%">-->
<!--                                <p-->
<!--                                    style="width: 25%; display: flex; justify-content: space-between"-->
<!--                                    v-for="(item, index) in itemBig.custaccounts_begin"-->
<!--                                    :key="index"-->
<!--                                >-->
<!--                                    <span style="margin-right: 10px">{{ item.style_name }}</span>-->
<!--                                    <span style="font-weight: normal">{{ item.value }}</span>-->
<!--                                </p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div v-if="DataDtl.custaccounts_now">-->
<!--                        <div-->
<!--                            class="sum2"-->
<!--                            v-if="DataDtl.custaccounts_now.is_show == 1"-->
<!--                            :style="`font-size:${DataDtl.custaccounts_now.font_size}px;`"-->
<!--                        >-->
<!--                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">本期存欠帐（正欠负存）:</span>-->
<!--                            <div style="display: flex; flex-wrap: wrap; width: 80%">-->
<!--                                <p-->
<!--                                    style="width: 25%; display: flex; justify-content: space-between"-->
<!--                                    v-for="(item, index) in itemBig.custaccounts_now"-->
<!--                                    :key="index"-->
<!--                                >-->
<!--                                    <span style="margin-right: 10px">{{ item.style_name }}</span>-->
<!--                                    <span style="font-weight: normal">{{ item.value }}</span>-->
<!--                                </p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div v-if="DataDtl.custaccounts_end">-->
<!--                        <div-->
<!--                            class="sum2"-->
<!--                            v-if="DataDtl.custaccounts_end.is_show == 1"-->
<!--                            :style="`font-size:${DataDtl.custaccounts_end.font_size}px;`"-->
<!--                        >-->
<!--                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">期末存欠帐（正欠负存）:</span>-->
<!--                            <div style="display: flex; flex-wrap: wrap; width: 80%">-->
<!--                                <p-->
<!--                                    style="width: 25%; display: flex; justify-content: space-between"-->
<!--                                    v-for="(item, index) in itemBig.custaccounts_end"-->
<!--                                    :key="index"-->
<!--                                >-->
<!--                                    <span style="margin-right: 10px">{{ item.style_name }}</span>-->
<!--                                    <span style="font-weight: normal">{{ item.value }}</span>-->
<!--                                </p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

                    <div v-if="DataDtl.custaccounts_begin || DataDtl.custaccounts_end || DataDtl.custaccounts_now">
                        <div
                            class="sum2"
                            v-for="(accountConfig, index) in sortedCustAccounts"
                            :key="index"
                            v-if="accountConfig && accountConfig.is_show == 1"
                            :style="`font-size:${accountConfig.font_size}px;`"
                        >
                            <span
                                style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">{{ accountConfig.label
                                }}:</span>
                            <div style="display: flex; flex-wrap: wrap; width: 80%">
                                <p style="width: 25%; display: flex; justify-content: space-between"
                                   v-for="(item, itemIndex) in itemBig[accountConfig.dataKey]"
                                   :key="itemIndex"
                                >
                                    <span style="margin-right: 10px">{{ item.style_name }}</span>
                                    <span style="font-weight: normal">{{ item.value }}</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div v-if="DataDtl.footer">
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <div class="sumBotn" style="width: 72%; margin-right: 8%">
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>制单：</span>
                                    <span>{{ itemBig.mains.build_name || '' }}</span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>复核：</span>
                                    <span></span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>业务员：</span>
                                    <span>{{ itemBig.mains.salesman_name || '' }}</span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                    <span>客户签名：</span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="text-align: right;">
                        <big-name v-if="DataDtl.tbrjphone_show == 1"></big-name>
                    </div>
                    <div v-if="DataDtl.remark.is_show == 1">
                        <p :style="`font-size:${DataDtl.remark.font_size}px; white-space: pre-wrap; word-wrap: break-word;`">{{ DataDtl.remark.content }}</p>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="toImg">转图片下载</el-button>
                <el-button type="primary" @click="printContext">直接打印</el-button>
                <el-button @click="printData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false" destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>

        <el-dialog style="padding: 0 0 20px" :title="$t('common.print')" :visible.sync="dialogFormVisible" width="35%">
            <div class="printBox" id="prints" ref="prints">
                <div v-for="(item, index) in LabelList" :key="index" style="page-break-after: always">
                    <div style="display: flex; align-items: center; justify-content: center">
                        <div style="display: flex; flex-direction: column; transform: rotate(270deg)">
                            <div style="margin-bottom: 15px; line-height: 1">
                                <div style="font-size: 16px; text-align: center">{{ systemSet.company }}</div>
                                <div style="font-size: 16px">{{ item.barcode_name }}</div>
                                <div style="display: flex; font-size: 14px">
                                    <div>总重:{{ item.wgt }}g</div>
                                    <div style="margin-left: 10px">{{ item.specs }}</div>
                                </div>
                                <div style="display: flex; font-size: 14px">
                                    <div>金重:{{ item.gold_wgt }}g</div>
                                    <div style="margin-left: 10px">银重:{{ item.silver_wgt }}g</div>
                                </div>
                                <div style="display: flex; font-size: 14px">
                                    <div>工费:{{ item.salewgt_prc }}/克</div>
                                    <div style="margin-left: 10px">件工费:{{ item.saleqty_prc }}</div>
                                </div>
                                <div style="font-size: 12px">合格证:QB/T1131-20</div>
                                <div style="font-size: 12px">执行标准:GB11887-20</div>
                            </div>
                            <div style="line-height: 1">
                                <div style="font-size: 16px">标签撕毁&emsp;不退不换</div>
                                <div style="font-size: 14px">款&nbsp;号：{{ item.style_no }}</div>
                                <div style="font-size: 14px">证&nbsp;书：{{ item.certificateno }}</div>
                                <div style="text-align: center">
                                    <img
                                        :id="'barcode' + index"
                                        style="
                                            height: 50px;
                                            width: 120px;
                                            margin: 0px;
                                            padding: 0px;
                                            shape-rendering: crispedges;
                                            image-rendering: optimizeQuality; /*改善下载后不会产生锯齿*/
                                            vector-effect: non-scaling-stroke;
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisibleModify()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="showImpotDialogCost" width="30%" :before-close="handleClose">
            <el-checkbox-group v-model="checkList">
                <el-checkbox label="减金料额"></el-checkbox>
                <el-checkbox label="减金料工费"></el-checkbox>
                <el-checkbox label="减银料额"></el-checkbox>
                <el-checkbox label="减银料工费"></el-checkbox>
                <el-checkbox label="减证书费"></el-checkbox>
                <el-checkbox label="减入库附加工费"></el-checkbox>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialogCost = false">取 消</el-button>
                <el-button type="primary" @click="closingCost">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { multiplication2, getExportExcel } from '@/utils/multAdexportExcel.js';
import {
    apiGoldsilverinGetData,
    apiGoldsilverinGetPull,
    apiGoldsilverinUpdateData,
    apiGoldsilverinAddData,
    apiGoldsilverinDelData,
    apiGoldsilverincheck,
    apiGoldsilverinIsAllowUp,
    apiGoldsilverinPriceAdMate,
    apiCurrentPermisson,
    apiSystem,
    apiGetDividedBtnInfo,
    apiIsOrderQuote,
    insjQuitSum,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData,
    getPrinOut_pull,
    apiGoldsilverinTempPrint,
    apiGetGoldSliveInPrintLink,
    apiGetGoldSliveInPrintLinkExport,
    apiCustStyleWage
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n';
export default {
    name: 'goldsilverin',
    data() {
        return {
            query: {},
            LabelList: {},
            dialogFormVisible: false,

            wgtTotal: 0,
            allArr: '',
            form: { remark: '' },
            isedit: true,
            isCheck: false,
            first: null,
            last: null,
            dialogImageUrl: '',
            dialogVisible: false,
            isAdd: false,
            loading: false,
            nullBtn: false,
            systemSet: '',
            dtlIndex: '-1', //列表当前位置,
            isSave: true,
            type: '4',
            maxHeight: 480,
            showImpotDialog: false,
            showImpotDialogCost: false,
            checkList: [],
            headers: {},
            topIptInsjOrder: '',
            topLeftForm: {},
            billIndex: '-1',
            amtIndex: '-1',

            // 批量字段
            batchSelect: '',
            selectRecords: 0,
            batchOption: '1',
            flagFalse: false,
            //列表擦操作字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            rkKeyList: [],
            zkKeyList: [],
            fkKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            originalZkKeyList: [], // 保存原始的列配置（包含所有语言）
            originalFkKeyList: [], // 保存原始的列配置（包含所有语言）
            keyStatus: '51',
            perData: {}, //权限

            // 打印字段
            printData: { isshow: false, scope: null, index: 0, data: {} },
            DataDtl: { is_cunqian: {}, is_tot: {}, remark: {}, company: {} },
            fields3: [],
            fields2: [],
            fields1: [],
            query: {},
            pullList: {},
            printList: {}
        };
    },
    computed: {
        sortedCustAccounts() {
            const accounts = [];

            if (this.DataDtl.custaccounts_begin) {
                accounts.push({
                    dataKey: 'custaccounts_begin',
                    label: '期初存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_begin.seq || 1,
                    is_show: this.DataDtl.custaccounts_begin.is_show,
                    font_size: this.DataDtl.custaccounts_begin.font_size
                });
            }

            if (this.DataDtl.custaccounts_end) {
                accounts.push({
                    dataKey: 'custaccounts_end',
                    label: '期末存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_end.seq || 2,
                    is_show: this.DataDtl.custaccounts_end.is_show,
                    font_size: this.DataDtl.custaccounts_end.font_size
                });
            }

            if (this.DataDtl.custaccounts_now) {
                accounts.push({
                    dataKey: 'custaccounts_now',
                    label: '本期存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_now.seq || 3,
                    is_show: this.DataDtl.custaccounts_now.is_show,
                    font_size: this.DataDtl.custaccounts_now.font_size
                });
            }

            return accounts.sort((a, b) => a.seq - b.seq);
        }
    },
    mounted() {
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        this.getStoneData();
        this.getPulls();
        this.getTable();
        this.getTable1();
        this.getTable2();
        this.getPermission();
        document.addEventListener('keydown.native', this.mykeyup);
        // this.geData();
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;
        if (this.$route.query.isadd == 0) {
            this.add();
        } else {
            this.geData();
        }
        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
                if (this.originalZkKeyList && this.originalZkKeyList.length > 0) {
                    this.zkKeyList = translateColumns(this.originalZkKeyList, newLang || 'zh-CN');
                }
                if (this.originalFkKeyList && this.originalFkKeyList.length > 0) {
                    this.fkKeyList = translateColumns(this.originalFkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    activated() {
        // if (this.$route.query.isadd == 0) {
        //     this.add();
        // } else {
        //     this.geData();
        // }
        let bill_no = this.$route.query.bill_no;
        if (bill_no) {
            this.geData();
        }
    },
    methods: {
        shouldFilterOptions(field) {
            // 根据 field 或其他条件判断是否需要过滤
            return field == 'style_no'; // 替换为你的逻辑
        },
        batchclick() {
            this.batchSelect = '';
        },
        batchOperation(e, r) {
            if (e.value) {
                var table1 = this.$refs.xTable1.getTableData().fullData;
                if (this.batchOption == '1') {
                    for (let i = 0; i < table1.length; i++) {
                        table1[i][r] = e.value;
                    }
                } else if (this.batchOption == '2') {
                    let selectedRowIndex = --this.selectRecords[0].seq;
                    for (let i = selectedRowIndex; i < table1.length; i++) {
                        table1[i][r] = e.value;
                    }
                } else if (this.batchOption == '3') {
                    for (let i = 0; i < table1.length; i++) {
                        table1[i][r] = Number(table1[i][r]) + Number(e.value);
                    }
                } else if (this.batchOption == '4') {
                    let selectedRowIndex = --this.selectRecords[0].seq;
                    for (let i = selectedRowIndex; i < table1.length; i++) {
                        table1[i][r] = Number(table1[i][r]) + Number(e.value);
                    }
                } else if (this.batchOption == '5') {
                    // 处理多个选中的行修改为指定值
                    for (let i = 0; i < this.selectRecords.length; i++) {
                        let selectedRowIndex = --this.selectRecords[i].seq;
                        if (selectedRowIndex >= 0 && selectedRowIndex < table1.length) {
                            table1[selectedRowIndex][r] = e.value; // 修改选中行的指定列值
                        }
                    }
                } else if (this.batchOption == '6') {
                    // 处理多个选中的行加减
                    for (let i = 0; i < this.selectRecords.length; i++) {
                        let selectedRowIndex = --this.selectRecords[i].seq;
                        if (selectedRowIndex >= 0 && selectedRowIndex < table1.length) {
                            // 对选中行进行加减
                            table1[selectedRowIndex][r] = Number(table1[selectedRowIndex][r]) + Number(e.value);
                        }
                    }
                }
                for (let i = 0; i < table1.length; i++) {
                    this.countGold(table1[i]);
                    this.countSilver(table1[i]);
                    this.countGoldAmt(table1[i]);
                    this.countSilverAmt(table1[i]);
                    this.calculationInAndOut(r, table1[i]);
                    this.countInamtOriginal(table1[i]);
                    this.countInAmtWage(table1[i]);
                    this.countOutAmtWage(table1[i]);
                    this.countInAmt(table1[i]);
                    this.countOutAmt(table1[i]);
                    this.countAmount(table1[i]);
                }
                this.flagFalse = false;
            }
        },
        checkboxChangeEvent({ records }) {
            this.selectRecords = records;
        },
        // 批量操作
        handleCommand(command) {
            if (command == 1) {
                this.labelClick();
            } else if (command == 2) {
                this.labelClick2();
            } else if (command == 3) {
                this.labelClick3();
            }
        },
        labelClick3() {
            let data = this.$refs.xTable1.getCheckboxRecords();
            let strId = [];
            if (data.length !== 0) {
                for (let i = 0; i < data.length; i++) {
                    strId.push(data[i].id);
                }
            }
            let params = {
                id: this.form.id,
                dtlid: strId.join(','),
                is_exports: 1
            };
            apiGetGoldSliveInPrintLinkExport(params)
                .then((res) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([res.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.$t('common.label') + '.xlsx'
                    link.click();
                    this.form.is_exports = 0;
                })
                .catch((error) => {
                    console.error('API Request Failed:', error); // 错误处理
                });
        },
        dialogVisibleModify() {
            this.dialogFormVisible = false;
            this.$print(this.$refs.prints);
        },
        labelClick2() {
            let data = this.$refs.xTable1.getCheckboxRecords();
            let strId = [];
            if (data.length !== 0) {
                for (let i = 0; i < data.length; i++) {
                    strId.push(data[i].id);
                }
            }
            let params = {
                id: this.form.id,
                dtlid: strId.join(',')
            };
            this.dialogFormVisible = true;
            apiGetGoldSliveInPrintLink(params).then((res) => {
                if (res.code == 2000) {
                    this.LabelList = res.data.data;
                    for (let index = 0; index < this.LabelList.length; index++) {
                        if (this.LabelList[index].barcode) {
                            this.$nextTick(() => {
                                // 待生成条码的内容
                                // this.LabelList[index].barcode
                                JsBarcode('#barcode' + index, this.LabelList[index].barcode, {
                                    // format: 'CODE39', //选择要使用的条形码类型
                                    width: 5, //设置条之间的宽度
                                    height: 280, //高度
                                    displayValue: true, //是否在条形码下方显示文字
                                    // text: '456', //覆盖显示的文本
                                    // fontOptions: 'bold italic', //使文字加粗体或变斜体
                                    font: '楷体', //设置文本的字体
                                    // textAlign: 'left', //设置文本的水平对齐方式
                                    // textPosition: 'top', //设置文本的垂直位置
                                    textMargin: 20, //设置条形码和文本之间的间距
                                    fontSize: 80 //设置文本的大小
                                    // background: '#eee', //设置条形码的背景
                                    // lineColor: '#2196f3' //设置条和文本的颜色。
                                    // margin: 10 //设置条形码周围的空白边距
                                });
                            });
                        }
                    }
                    // console.log(res.data);
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 标签打印
        labelClick() {
            let data = this.$refs.xTable1.getCheckboxRecords();
            let strId = [];
            if (data.length !== 0) {
                for (let i = 0; i < data.length; i++) {
                    strId.push(data[i].id);
                }
            }
            let params = {
                id: this.form.id,
                dtlid: strId.join(',')
            };
            apiGetGoldSliveInPrintLink(params).then((res) => {
                if (res.code == 2000) {
                    this.$router.push({
                        path: '/printingfusion',
                        query: {
                            url: res.data.Url
                        }
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },

        getPulls() {
            let path_code = this.$route.path.replace('/', '');
            getPrinOut_pull({ code: path_code }).then((res) => {
                this.pullList = res.data;
                this.query.model_name = this.pullList.model_data.id;
                this.printType = this.pullList.model_data.name;
            });
        },
        // 打印
        printOut() {
            this.getPulls();
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiGoldsilverinTempPrint({
                id: this.form.id,
                print_id: this.query.model_name
            }).then((res) => {
                console.log(res, 'aa');
                if (res.code == 2000) {
                    this.printData.isshow = true;
                    loading.close();
                    this.printList = res.data.bill;
                    //模板打印数据
                    this.DataDtl = res.data.print;
                    this.fields3 = this.DataDtl.fields3;
                    this.fields2 = this.DataDtl.fields2;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },

        // 选择打印下拉框-----------------------
        selectPrints(val) {
            let modelList = this.pullList.model;
            this.printType = modelList.find((item) => item.id == val).name;
            let id = modelList.find((item) => item.id == val).id;
            this.query.model_name = val;
            this.printOutTwo();
            this.$forceUpdate();
        },
        printOutTwo() {
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiGoldsilverinTempPrint({
                id: this.form.id,
                print_id: this.query.model_name
            }).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.printList = res.data.bill;
                    //模板打印数据
                    this.DataDtl = res.data.print;
                    this.fields3 = this.DataDtl.fields3;
                    this.fields2 = this.DataDtl.fields2;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    // this.$message.error(res.data.info);
                    this.printOut();
                }
            });
        },
        toImg() {
            this.$html2canvas(this.$refs.print, {
                backgroundColor: 'white',
                useCORS: true,
                windowHeight: document.body.scrollHeight
            }).then((canvas) => {
                let url = canvas.toDataURL();
                this.img = url;
                this.download();
            });
        },
        //下载图片
        download() {
            let imgData = this.img;
            this.downloadFile(this.printType + '.png', imgData);
        },
        //下载
        downloadFile(fileName, content) {
            let aLink = document.createElement('a');
            let blob = this.base64ToBlob(content); //new Blob([content]);

            let evt = document.createEvent('HTMLEvents');
            evt.initEvent('click', true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);
            aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); //兼容火狐
        },
        //base64转blob
        base64ToBlob(code) {
            let parts = code.split(';base64,');
            let contentType = parts[0].split(':')[1];
            let raw = window.atob(parts[1]);
            let rawLength = raw.length;

            let uInt8Array = new Uint8Array(rawLength);

            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: contentType });
        },
        printContext() {
            this.$print(this.$refs.print);
        },
        // 快捷键保存
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                // this.save('hot key');
                if (!this.isedit) {
                    if (this.$route.path == '/goldsilverin') {
                        this.saveItSub();
                        e.preventDefault();
                        e.returnValue = false;
                    }
                }
            }
        },

        closingCost() {
            // 遍历表格数据，计算折扣金额
            let table1 = this.$refs.xTable1.getTableData().fullData;
            for (let i = 0; i < table1.length; i++) {
                let discountAmount = 0;
                // 如果勾选了“减银料额”，计算银料额相关的折扣
                if (this.checkList.includes('减银料额')) {
                    discountAmount += multiplication2(
                        table1[i].silver_qty,
                        table1[i].silver_qty_prc,
                        table1[i].silver_wgt,
                        table1[i].silver_wgt_prc
                    );
                }
                if (this.checkList.includes('减银料工费')) {
                    discountAmount += multiplication2(
                        table1[i].silver_qty,
                        table1[i].silver_qtywage,
                        table1[i].silver_wgt,
                        table1[i].silver_wgtwage
                    );
                }

                // 如果勾选了“减金料额”，计算金料额相关的折扣
                if (this.checkList.includes('减金料额')) {
                    discountAmount += multiplication2(
                        table1[i].gold_qty,
                        table1[i].gold_qty_prc,
                        table1[i].gold_wgt,
                        table1[i].gold_wgt_prc
                    );
                }
                if (this.checkList.includes('减金料工费')) {
                    discountAmount += multiplication2(
                        table1[i].gold_qty,
                        table1[i].gold_qtywage,
                        table1[i].gold_wgt,
                        table1[i].gold_wgtwage
                    );
                }

                if (this.checkList.includes('减证书费')) {
                    discountAmount += Number(table1[i].certificate_amt || 0);
                }
                if (this.checkList.includes('减入库附加工费')) {
                    discountAmount += Number(table1[i].inadd_wage || 0);
                }
                // 更新入库优惠金额
                table1[i].inamt_discount = discountAmount;

                // 更新入库金额
                this.countInAmt(table1[i]);
            }

            // 关闭弹窗
            this.showImpotDialogCost = false;
        },

        closingCopy() {
            if (this.selectRecords.length > 1) {
                this.$message.error('仅可选择一行复制');
                return;
            } else {
                const filteredRecords = this.selectRecords.map((record) => {
                    const { barcode, ...rest } = record;
                    return rest;
                });

                this.$refs.xTable1.insertAt(filteredRecords, -1);
            }
        },
        closingPrice(type) {
            let dtl = JSON.stringify(this.$refs.xTable1.getTableData().fullData);
            apiGoldsilverinPriceAdMate({
                type,
                dtl
            }).then((res) => {
                this.form.bill = res.data.bill;
                this.form.sumqty = res.data.all.sum;
                this.form.balprc_qty = res.data.all.jie_sum;
                this.form.sumwgt = res.data.all.wgt;
                this.form.balqty_wgt = res.data.all.jie_wgt;
                // this.form.settle_amt = res.data.all.pay_fu;
                this.form.sumamt = this.$formatOrderAmt(Number(res.data.all.amt_pay) + Number(this.dtl_amt_pay), this.systemSet.zero_deal, this.systemSet.amt);
                this.form.sumamt2 = (Number(res.data.all.amt_pay) + Number(this.dtl_amt_pay)).toFixed(this.systemSet.amt);
                this.form.tran_wgt = res.data.all.liao_wgt;
                this.form.tran_qty = res.data.all.liao_sum;
                this.$forceUpdate();
                setTimeout(() => {
                    const $table = this.$refs.billTable;
                    $table.updateFooter();
                }, 100);
            });
        },
        amtenter(row) {
            if (!this.isedit) {
                this.amtIndex = row.$rowIndex;
            }
        },
        amtleave() {
            this.amtIndex = '-1';
        },
        billenter(row) {
            if (!this.isedit) {
                this.billIndex = row.seq;
            }
        },
        billleave() {
            this.billIndex = '-1';
        },
        handleClose(done) {
            this.showImpotDialog = false;
            this.showImpotDialogCost = false;
            // this.$confirm('确认关闭？')
            //     .then((_) => {
            //         done();
            //     })
            //     .catch((_) => {});
        },
        // 拖拽成功的钩子
        uploadSuccess(res) {
            if (res.code == 2000) {
                this.$message.success(res.msg);
                this.form.dtl = res.data;
                this.showImpotDialog = false;
            } else {
                if (res.data.info instanceof Array) {
                    let str = [];
                    var s = '';
                    str = res.data.info;
                    for (let i = 0; i < str.length; i++) {
                        s += str[i] + '<br/>';
                    }
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: s
                    });
                } else {
                    this.$message.success(res.data.info);
                }
            }
        },
        uploadError(r) {
            this.$message.error('上传失败');
        },
        outTem() {
            this.$axios
                .get(`${this.$baseURL}template_export_goldsilverin`, {
                    params: {
                        token: this.token,
                        type: '明细'
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data]);
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '明细导入模板.xls';
                    link.click();
                });
        },
        // 获取页面信息-----------------------------------------
        geData(no) {
            this.$load.show();
            this.isedit = true;
            let bill_nos = this.$route.query.bill_no;
            let ids = this.$route.query.id;
            let bill_no = '';
            let id = '';
            if (bill_nos || ids) {
                this.type = null;
                bill_no = bill_nos;
                id = ids;
            }
            if (no) {
                id = no;
            }
            this.isAdd = false;
            apiGoldsilverinGetData({
                type: this.type,
                id,
                bill_no
            }).then((res) => {
                if (res.code == 2000) {
                    let info = res.data;
                    this.form = info.data;
                    this.last = info.last;
                    this.first = info.first;
                    this.topLeftForm = info.data.inmain;
                    this.maxHeight = 480;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                    if (res.data.data.dtl.length > 4) {
                        let length = res.data.data.dtl.length - 4;
                        if (res.data.dtl.length > 10) {
                            length = 6;
                        }
                        let addHeight = length * 48;
                        this.maxHeight += addHeight;
                    }
                } else {
                    this.type = '4';
                    if (res.data.info == '暂无数据' || res.data.info == '没有这条数据') {
                        this.form = { dtl: [], bill: [], amt: [] };
                        this.$forceUpdate();
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                }
            });
            this.$load.close();
        },

        //列配置相关接口
        getTable() {
            apiGetListCorrespondingData({
                id: '51'
            }).then((res) => {
                // this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        getTable1() {
            apiGetListCorrespondingData({
                id: '52'
            }).then((res) => {
                // this.zkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalZkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.zkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        getTable2() {
            apiGetListCorrespondingData({
                id: '53'
            }).then((res) => {
                // this.fkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalFkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.fkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        changeTable(type) {
            if (type == 1) {
                this.keyList = this.rkKeyList.map((item) => item);
                this.keyStatus = '51';
            } else if (type == 2) {
                this.keyList = this.zkKeyList.map((item) => item);
                this.keyStatus = '52';
            } else if (type == 3) {
                this.keyList = this.fkKeyList.map((item) => item);
                this.keyStatus = '53';
            }
            this.drawers = true;
        },

        checkMove() {},
        keycancel() {
            this.drawers = false;
            this.getTable();
            this.getTable1();
            this.getTable2();
        },
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 获取下拉框信息---------------------------------------
        getStoneData() {
            apiGoldsilverinGetPull({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        async getDivideInfo(t) {
            if (this.topIptInsjOrder.trim() == '') {
                this.$message.info('请输入入库单号后进行查询');
                return;
            }
            let isuse = await apiIsOrderQuote({ insj_no: this.topIptInsjOrder });
            if (isuse.data.isUse == 0) {
                this.getPassTestData(t);
            } else {
                this.$confirm('此入库单号已被引用，是否继续？', '提示', {
                    confirmButtonText: this.$t('common.confirm') ,
                    cancelButtonText: this.$t('common.cancel') ,
                    type: 'warning'
                })
                    .then(() => {
                        this.getPassTestData(t);
                    })
                    .catch(() => {
                        this.topIptInsjOrder = '';
                    });
            }
            return;
        },
        getPassTestData(t) {
            apiGetDividedBtnInfo({ insj_no: this.topIptInsjOrder }).then((res) => {
                if (res.code === 2000) {
                    this.topLeftForm = res.data.inmain;
                    if (t == 'btn') {
                        this.form.dtl = res.data.indtl;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
                this.topIptInsjOrder = '';
            });
        },
        iptKeydownEvent(e) {
            if (e.keyCode === 13) {
                this.getDivideInfo('ipt');
            }
        },
        changeData(row, type, e) {
            // 假设我们已经有了 type 和 row 的定义
            const selectedNo = row[`${type}_no`]; // 获取当前行的编号
            const arrayToSearch = this.allArr[type]; // 获取数据源

            const idx = arrayToSearch.findIndex((item) => item[`${type}_no`] === selectedNo); // 找到索引

            const info = arrayToSearch[idx]; // 取出相应的信息

            if (e == 'dtl') {
                if (type + '_no' == 'style_no') {
                    apiCustStyleWage({ cust_no: this.form.cust_no, style_no: selectedNo }).then((res) => {
                        if (res.code == 2000) {
                            for (var item in res.data) {
                                row[item] = res.data[item];
                            }
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                }
                row.gold_style_no = info.gold_style_no;
                row.silver_style_no = info.silver_style_no;
            }
            if (!Array.isArray(arrayToSearch)) {
                console.error(`allArr[${type}] is not an array or is undefined`);
                return; // 如果 arrayToSearch 不是数组，直接返回
            }

            if (idx !== -1) {
                // 在这里，我们只更新 row[`${type}_no`] 和 row[`${type}_name`]，而不改变其他值
                row[`${type}_no`] = info[`${type}_no`]; // 更新当前行的编号
                row[`${type}_name`] = info[`${type}_name`]; // 更新当前行的名称
            } else {
                console.warn(`No entry found for selectedNo: ${selectedNo}`);
            }
        },
        exportFile() {
            getExportExcel('billexport_goldsilverin', { id: this.form.id }, '金包银采购入库');
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isedit = true;
            this.isAdd = false;
            this.form = { dtl: [] };
            this.geData(no);
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/goldsilverin');
            }
        },
        //首次进入页面 页面不可编辑状态--------------------------------
        handelEdit() {
            apiGoldsilverinIsAllowUp({ id: this.form.id }).then((res) => {
                if (res.code === 2000) {
                    this.isSave = true;
                    if (this.isedit == true) {
                        if (this.form.check == 0) {
                            this.isedit = false;
                            if (this.form.amt.length == 0) {
                                this.insertEvent2(-1);
                            }
                            if (this.form.dtl.length == 0) {
                                this.insertEvent(-1);
                            }
                            if (this.form.bill.length == 0) {
                                this.insertEvent1(-1);
                            }
                        } else if (this.form.check == 1) {
                            this.isCheck = true;
                        }
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 保存
        saveItSub() {
            const billArray = Array.isArray(this.form.bill) ? this.form.bill : [];

            // 检查是否存在结价金额为0的记录
            const hasInvalidBillItems = billArray.some(
                // item => item.bill_mode_no === 'BALPRC' && item.style_no && (!item.amt || item.amt == 0)
                item => {
                    // 查找 pullList.bill_mode 中 bill_mode_no 相同且 mode 为 0 的项
                    const billModes = this.pullList.bill_mode || [];
                    const matchingBillMode = billModes.find(
                        mode => mode.bill_mode_no === item.bill_mode_no && mode.mode === 0
                    );
                    return matchingBillMode && item.style_no && (!item.amt || item.amt == 0);
                }
            );

            // 检查是否存在结料且金额不为0的记录
            const hasInvalidTranItems = billArray.some(
                // item => item.bill_mode_no === 'TRAN' && item.style_no && item.amt && item.amt != 0
                item => {
                    // 查找 pullList.bill_mode 中 bill_mode_no 相同且 mode 为 1 或 -1 的项
                    const billModes = this.pullList.bill_mode || [];
                    const matchingBillMode = billModes.find(
                        mode => mode.bill_mode_no === item.bill_mode_no && (mode.mode === 1 || mode.mode === -1)
                    );
                    return matchingBillMode && item.style_no && item.amt && item.amt != 0;
                }
            );

            if (hasInvalidBillItems) {
                this.$confirm('账款明细存在结价金额为0的记录，是否继续保存？', '提示', {
                    type: 'warning'
                }).then(() => this.proceedToSave()).catch(() => {});
            } else if (hasInvalidTranItems) {
                this.$confirm('账款明细存在结料且金额不为0的记录，是否继续保存？', '提示', {
                    type: 'warning'
                }).then(() => this.proceedToSave()).catch(() => {});
            } else {
                this.proceedToSave();
            }
        },

        proceedToSave() {
            if (Number(this.wgtTotal) != Number(this.totalWgt)) {
                this.$confirm('账款明细重量与货品明细重量不一致，是否保存？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        this.saveIt();
                    })
                    .catch(() => {});
            } else {
                this.saveIt();
            }
        },
        // 保存修改------------------------------------------
        saveIt() {
            if (this.isSave) {
                this.isSave = false;
                let data = this.$deepClone(this.form);
                // console.log(this.form, '妈的喜欢乱写');
                let dtl = this.$refs.xTable1.getTableData().fullData;
                data.dtl = dtl;
                data['inmain'] = this.topLeftForm;
                data['check'] = this.form.check == true ? '1' : '0';
                data.bill = this.$refs.billTable.getTableData().fullData;
                data.amt = this.$refs.amtTable.getTableData().fullData;

                // return;
                this.$load.show();
                if (this.isAdd == true) {
                    apiGoldsilverinAddData({ ...data }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功'); //添加商品
                            let info = res.data;
                            this.form = info.data;
                            this.last = info.last;
                            this.first = info.first;
                            this.topLeftForm = info.data.inmain;
                            this.isAdd = false;
                            this.isedit = true;
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/goldsilverin');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                } else {
                    apiGoldsilverinUpdateData({ ...data }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('修改成功'); //修改商品
                            let info = res.data;
                            this.form = info.data;
                            this.last = info.last;
                            this.first = info.first;
                            this.topLeftForm = info.data.inmain;
                            this.isedit = true;
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                }
            }
        },
        selectCust(value) {
            if (value) {
                let item = this.allArr.cust.filter((item) => item.cust_no == value);
                this.$set(this.form, 'salesman_no', item[0].salesman_no);
                this.$forceUpdate();
            }
        },
        //添加产品-----------------------------------
        add() {
            this.isSave = true;
            if (this.isAdd == false) {
                this.isedit = false;
                this.form = { bill_date: '' };
                this.topLeftForm = {};
                this.form.check = false;
                this.isAdd = true;
                this.isCheck = false;
                this.nullBtn = false;
                this.form.bill_date = this.$getTime();
                this.maxHeight = 480;
                const keys = Object.keys(this.allArr);
                const formKeys = keys.map((key) => `${key}_no`);
                keys.forEach((key, index) => {
                    if (Array.isArray(this.allArr[key])) {
                        // 确保 this.allArr[key] 是一个数组，而不是 undefined 或 null
                        const defaultItem = this.allArr[key].find((item) => item.isdefault == 1);
                        if (defaultItem) {
                            // 确保 defaultItem 和属性 formKeys[index] 存在
                            if (defaultItem.hasOwnProperty(formKeys[index])) {
                                this.form[formKeys[index]] = defaultItem[formKeys[index]];
                            } else {
                                console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                                this.form[formKeys[index]] = ''; // 如果属性不存在，给它赋个默认值
                            }
                        } else {
                            // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                            console.warn(`No defaultItem found for key ${key}`);
                            this.form[formKeys[index]] = '';
                        }
                    } else {
                        // 如果 this.allArr[key] 不是一个数组，输出警告
                        console.warn(`Expected an array for key ${key}, but found ${typeof this.allArr[key]}`);
                    }
                });
                setTimeout(() => {
                    for (let i = 0; i < 3; i++) {
                        this.insertEvent(-1);
                        this.insertEvent1(-1);
                        this.insertEvent2(-1);
                    }
                }, 100);
            } else {
                this.$message.error('请先保存再添加下一个');
            }
            this.type = '4';
        },
        //删除产品-----------------------------------------
        delOrder() {
            apiGoldsilverinIsAllowUp({ id: this.form.id }).then((res) => {
                if (res.code === 2000) {
                    this.$confirm('确定要删除吗？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        apiGoldsilverinDelData({
                            id: this.form.id
                        }).then((res) => {
                            if (res.code == 2000) {
                                this.$message({ message: '删除成功', type: 'success' });
                                if (res.data.data == null) {
                                    this.form = {};
                                    this.nullBtn = true;
                                } else {
                                    this.form = res.data.data;
                                    if (this.form.check == 1) {
                                        this.isCheck = true;
                                    } else {
                                        this.isCheck = false;
                                    }
                                }
                                this.last = res.data.last;
                                this.first = res.data.first;
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        //审核按钮
        Check(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apiGoldsilverincheck({
                id: this.form.id,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    if (this.form.check == 0) {
                        this.isCheck = true;
                    } else {
                        this.isedit = true;
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
                this.type = '';
                this.geData(this.form.id);
            });
        },
        changePage(v) {
            this.type = v;
            let bill_nos = this.$route.query.bill_no;
            if (bill_nos) {
                this.$router.replace({ path: '/goldsilverin' });
                this.geData(this.form.id);
                return;
            }
            this.geData(this.form.id);
        },
        //插入新数据--------------------------------------------
        async insertEvent(row) {
            let record = {
                style_no: '',
                alloy: 1,
                qty: 1,
                counter_no: ''
            };
            let { row: newRow } = await this.$refs.xTable1.insertAt(record, row);
            await this.$refs.xTable1.setActiveCell(newRow, 'seq');
            // this.$refs.stylefocus.focus();
        },
        //tbale增加条数
        async insertEvent1(row) {
            let record = {
                discount: 1,
                alloy: 1
            };
            let { row: newRow } = await this.$refs.billTable.insertAt(record, row);
            await this.$refs.billTable.setActiveCell(newRow, 'seq');
        },
        async insertEvent2(row) {
            let record = {
                currency_no: this.systemSet.currency_no
            };
            let { row: newRow } = await this.$refs.amtTable.insertAt(record, row);
            await this.$refs.amtTable.setActiveCell(newRow, 'seq');
        },
        // 新增账款明细
        addbill() {
            this.insertEvent1(-1);
        },
        delbill(scoped) {
            let length = this.$refs.billTable.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.billTable.remove(scoped.row);
        },
        // 新增付款明细
        addamt() {
            this.insertEvent2(-1);
        },
        delamt(scoped) {
            let length = this.$refs.amtTable.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.amtTable.remove(scoped.row);
        },
        // 不可编辑-------------------------------------
        activeRowMethod() {
            if (this.isedit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },
        // 含金量  含银量
        countGold(row) {
            var a = Number(row.wgt) ? (Number(row.gold_wgt || 0) / Number(row.wgt)) * 100 : 0;
            row.gold_content = a.toFixed(this.systemSet.wgt);
            return a;
        },
        countSilver(row) {
            var a = Number(row.wgt) ? (Number(row.silver_wgt || 0) / Number(row.wgt || 0)) * 100 : 0;
            row.silver_content = a.toFixed(this.systemSet.wgt);
            return a ? a : 0;
        },
        countGoldAmt(row) {
            var a = multiplication2(row.gold_qty, row.gold_qty_prc, row.gold_wgt, row.gold_wgt_prc);
            row.gold_amt = a.toFixed(this.systemSet.amt);
            return a ? a : 0;
        },
        countSilverAmt(row) {
            var a = multiplication2(row.silver_qty, row.silver_qty_prc, row.silver_wgt, row.silver_wgt_prc);
            row.silver_amt = a.toFixed(this.systemSet.amt);
            return a ? a : 0;
        },
        calculationInAndOut(type, row) {
            if (type === 'mainstone_amt') {
                let a =
                    multiplication2(row.mainstone_qty, row.mainstone_qty_prc, row.mainstone_qty, row.mainstone_qty_wage) +
                    multiplication2(row.mainstone_wgt, row.mainstone_wgt_prc, row.mainstone_wgt, row.mainstone_wgt_wage);
                row.mainstone_amt = a || 0;
                return row.mainstone_amt || 0;
            } else if (type === 'stone1_amt') {
                let a =
                    multiplication2(row.stone1_qty, row.stone1_qty_prc, row.stone1_qty, row.stone1_qty_wage) +
                    multiplication2(row.stone1_wgt, row.stone1_wgt_prc, row.stone1_wgt, row.stone1_wgt_wage);
                row.stone1_amt = a || 0;
                return row.stone1_amt || 0;
            } else if (type === 'stone2_amt') {
                let a =
                    multiplication2(row.stone2_qty, row.stone2_qty_prc, row.stone2_qty, row.stone2_qty_wage) +
                    multiplication2(row.stone2_wgt, row.stone2_wgt_prc, row.stone2_wgt, row.stone2_wgt_wage);
                row.stone2_amt = a || 0;
                return row.stone2_amt || 0;
            } else if (type === 'stone3_amt') {
                let a =
                    multiplication2(row.stone3_qty, row.stone3_qty_prc, row.stone3_qty, row.stone3_qty_wage) +
                    multiplication2(row.stone3_wgt, row.stone3_wgt_prc, row.stone3_wgt, row.stone3_wgt_wage);
                row.stone3_amt = a || 0;
                return row.stone3_amt || 0;
            } else if (type === 'stone4_amt') {
                let a =
                    multiplication2(row.stone4_qty, row.stone4_qty_prc, row.stone4_qty, row.stone4_qty_wage) +
                    multiplication2(row.stone4_wgt, row.stone4_wgt_prc, row.stone4_wgt, row.stone4_wgt_wage);
                row.stone4_amt = a || 0;
                return row.stone4_amt || 0;
            } else if (type === 'stone5_amt') {
                let a =
                    multiplication2(row.stone5_qty, row.stone5_qty_prc, row.stone5_qty, row.stone5_qty_wage) +
                    multiplication2(row.stone5_wgt, row.stone5_wgt_prc, row.stone5_wgt, row.stone5_wgt_wage);
                row.stone5_amt = a || 0;
                return row.stone5_amt || 0;
            } else if (type === 'stone_amt') {
                let a =
                    Number(row.mainstone_amt || 0) +
                    Number(row.stone1_amt || 0) +
                    Number(row.stone2_amt || 0) +
                    Number(row.stone3_amt || 0) +
                    Number(row.stone4_amt || 0) +
                    Number(row.stone5_amt || 0);
                row.stone_amt = a || 0;
                return row.stone_amt || 0;
            } else if (type === 'mainstone_sale_amt') {
                let a =
                    multiplication2(row.mainstone_qty, row.mainstone_sale_qty_prc, row.mainstone_qty, row.mainstone_sale_qty_wage) +
                    multiplication2(row.mainstone_wgt, row.mainstone_sale_wgt_prc, row.mainstone_wgt, row.mainstone_sale_wgt_wage);
                row.mainstone_sale_amt = a || 0;
                return row.mainstone_sale_amt || 0;
            } else if (type === 'stone1_sale_amt') {
                let a =
                    multiplication2(row.stone1_qty, row.stone1_sale_qty_prc, row.stone1_qty, row.stone1_sale_qty_wage) +
                    multiplication2(row.stone1_wgt, row.stone1_sale_wgt_prc, row.stone1_wgt, row.stone1_sale_wgt_wage);
                row.stone1_sale_amt = a || 0;
                return row.stone1_sale_amt || 0;
            } else if (type === 'stone2_sale_amt') {
                let a =
                    multiplication2(row.stone2_qty, row.stone2_sale_qty_prc, row.stone2_qty, row.stone2_sale_qty_wage) +
                    multiplication2(row.stone2_wgt, row.stone2_sale_wgt_prc, row.stone2_wgt, row.stone2_sale_wgt_wage);
                row.stone2_sale_amt = a || 0;
                return row.stone2_sale_amt || 0;
            } else if (type === 'stone3_sale_amt') {
                let a =
                    multiplication2(row.stone3_qty, row.stone3_sale_qty_prc, row.stone3_qty, row.stone3_sale_qty_wage) +
                    multiplication2(row.stone3_wgt, row.stone3_sale_wgt_prc, row.stone3_wgt, row.stone3_sale_wgt_wage);
                row.stone3_sale_amt = a || 0;
                return row.stone3_sale_amt || 0;
            } else if (type === 'stone4_sale_amt') {
                let a =
                    multiplication2(row.stone4_qty, row.stone4_sale_qty_prc, row.stone4_qty, row.stone4_sale_qty_wage) +
                    multiplication2(row.stone4_wgt, row.stone4_sale_wgt_prc, row.stone4_wgt, row.stone4_sale_wgt_wage);
                row.stone4_sale_amt = a || 0;
                return row.stone4_sale_amt || 0;
            } else if (type === 'stone5_sale_amt') {
                let a =
                    multiplication2(row.stone5_qty, row.stone5_sale_qty_prc, row.stone5_qty, row.stone5_sale_qty_wage) +
                    multiplication2(row.stone5_wgt, row.stone5_sale_wgt_prc, row.stone5_wgt, row.stone5_sale_wgt_wage);
                row.stone5_sale_amt = a || 0;
                return row.stone5_sale_amt || 0;
            } else if (type === 'stone_sale_amt') {
                let a =
                    Number(row.mainstone_sale_amt || 0) +
                    Number(row.stone1_sale_amt || 0) +
                    Number(row.stone2_sale_amt || 0) +
                    Number(row.stone3_sale_amt || 0) +
                    Number(row.stone4_sale_amt || 0) +
                    Number(row.stone5_sale_amt || 0);
                row.stone_sale_amt = a || 0;
                return row.stone_sale_amt || 0;
            }
        },
        countInamtOriginal(row) {
            let a =
                Number(row.inamt_wage || 0) +
                Number(row.gold_amt || 0) +
                Number(row.silver_amt || 0) +
                Number(row.certificate_amt || 0) +
                Number(row.stone_amt || 0);
            row.inamt_original = a.toFixed(this.systemSet.amt);
            return a ? a : 0;
        },
        countInAmtWage(row) {
            var a =
                Number(row.qty || 0) * Number(row.inqty_prc || 0) +
                Number(row.wgt || 0) * Number(row.inwgt_prc || 0) +
                Number(row.qty || 0) * Number(row.inadd_qtywage || 0) +
                Number(row.wgt || 0) * Number(row.inadd_wgtwage || 0) +
                Number(row.inadd_wage || 0) +
                Number(row.gold_qty || 0) * Number(row.gold_qtywage || 0) +
                Number(row.gold_wgt || 0) * Number(row.gold_wgtwage || 0) +
                Number(row.silver_qty || 0) * Number(row.silver_qtywage || 0) +
                Number(row.silver_wgt || 0) * Number(row.silver_wgtwage || 0);
            row.inamt_wage = a.toFixed(this.systemSet.amt);
            return a ? a : 0;
        },
        countOutAmtWage(row) {
            var a =
                Number(row.qty || 0) * Number(row.saleqty_prc || 0) +
                Number(row.wgt || 0) * Number(row.salewgt_prc || 0) +
                Number(row.qty || 0) * Number(row.saleadd_qtywage || 0) +
                Number(row.wgt || 0) * Number(row.saleadd_wgtwage || 0) +
                Number(row.saleadd_wage || 0) +
                Number(row.gold_qty || 0) * Number(row.gold_qtywage || 0) +
                Number(row.gold_wgt || 0) * Number(row.gold_wgtwage || 0) +
                Number(row.silver_qty || 0) * Number(row.silver_qtywage || 0) +
                Number(row.silver_wgt || 0) * Number(row.silver_wgtwage || 0);
            row.saleamt_wage = a.toFixed(this.systemSet.amt);
            return a ? a : 0;
        },
        countInAmt(row) {
            var a =
                Number(row.inamt_wage || 0) +
                Number(row.gold_amt || 0) +
                Number(row.silver_amt || 0) +
                Number(row.certificate_amt || 0) +
                Number(row.stone_amt || 0) -
                Number(row.inamt_discount || 0);
            row.inamt = a.toFixed(this.systemSet.amt);
            return a ? a : 0;
        },
        countOutAmt(row) {
            var a =
                Number(row.saleamt_wage || 0) +
                // Number(row.gold_amt || 0) +
                // Number(row.silver_amt || 0) +
                // Number(row.certificate_amt || 0) +
                Number(row.stone_sale_amt || 0);
            row.saleamt = a.toFixed(this.systemSet.amt);
            return a ? a : 0;
        },
        // countAllAmount(data) {
        //     return this.$utils.sum(data.map((row) => this.countAmount(row)));
        // },
        countAmount(row) {
            var b = this.$utils.multiply(row.wgt, row.alloy);
            row.trans_wgt = Number(b).toFixed(this.systemSet.wgt);
            return b;
        },
        countMoney1(row) {
            this.countAmount(row)
            var a =
                (Number(row.wgt_prc || 0) * Number(row.trans_wgt || 0) + Number(row.qty || 0) * Number(row.qty_prc || 0)) *
                Number(row.discount || 0);
            row.amt = Number(a).toFixed(this.systemSet.amt);
            return a;
        },
        countMoney2(row) {
            var a = Number(row.wgt_prc || 0) * Number(row.wgt || 0) + Number(row.qty || 0) * Number(row.qty_prc || 0);
            row.original_amt = Number(a).toFixed(this.systemSet.amt);

            return a;
        },
        sumNum(list, field) {
            let count = 0;
            list.forEach((item) => {
                count += Number(item[field]);
            });
            return count;
        },
        // 表尾合计---------------------------------
        footerMethod({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    } else if (column.property == 'wgt') {
                        this.$forceUpdate();
                        let totalWgt = this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt);
                        this.wgtTotal = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                        // this.form.sumwgt = `${totalWgt ? totalWgt : 0} `;
                        this.$set(this.form, 'sumwgt', totalWgt);
                        return `${totalWgt} `;
                    } else if (column.property == 'trans_wgt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)} `;
                    } else if (column.property == 'inamt') {
                        this.dtl_amt_pay = `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                        this.form.sumamt = this.$formatOrderAmt(Number(this.bill_amt_pay) + Number(this.dtl_amt_pay), this.systemSet.zero_deal, this.systemSet.amt);
                        this.form.sumamt2 = (Number(this.bill_amt_pay) + Number(this.dtl_amt_pay)).toFixed(this.systemSet.amt);
                        this.$forceUpdate();
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                    } else if (column.property == 'qty') {
                        let totalQty = this.$utils.sum(data, column.property).toFixed(this.systemSet.qty);
                        // this.form.sumqty = `${totalQty ? totalQty : 0} `;
                        this.$set(this.form, 'sumqty', totalQty);
                        return `${totalQty} `;
                    } else if (column.property == 'saleamt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                    } else if (column.property == 'gold_amt') {
                        this.form.gold_amt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)}`;
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                    } else if (column.property == 'silver_amt') {
                        this.form.silver_amt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)}`;
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                    } else if (column.property == 'inamt_wage') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                    } else if (column.property == 'saleamt_wage') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                    } else if (column.property == 'gold_wgt') {
                        this.form.gold_wgt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)} `;
                    } else if (column.property == 'silver_wgt') {
                        this.form.silver_wgt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)} `;
                    } else if (column.property == 'inamt_original') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        footerMethod1({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    } else if (column.property == 'wgt') {
                        this.totalWgt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.wgt)}`;
                    } else if (column.property == 'qty') {
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.qty)}`;
                    } else if (column.property == 'original_amt') {
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else if (column.property == 'amt') {
                        this.bill_amt_pay = `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                        this.form.sumamt = this.$formatOrderAmt(Number(this.bill_amt_pay) + Number(this.dtl_amt_pay), this.systemSet.zero_deal, this.systemSet.amt);
                        this.form.sumamt2 = (Number(this.bill_amt_pay) + Number(this.dtl_amt_pay)).toFixed(this.systemSet.amt);
                        this.$forceUpdate();
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else if (column.property == 'trans_wgt') {
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.wgt)}`;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        footerMethod2({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    } else if (column.property == 'amt') {
                        this.form.settle_amt = `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                        this.$forceUpdate();
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        editClosedEvent() {
            this.foottotal();
        },
        foottotal() {
            let dtl = this.$refs.xTable1.getTableData().fullData;
            let bill = this.$refs.billTable.getTableData().fullData;
            let amt = this.$refs.amtTable.getTableData().fullData;
            insjQuitSum({ dtl, bill, amt }).then((res) => {
                this.form.sumqty = res.data.sumqty;
                this.form.sumwgt = res.data.sumwgt;
                this.form.sumtrans_wgt = res.data.sumtrans_wgt;
                this.form.settle_amt = res.data.settle_amt;
                this.form.tran_qty = res.data.tran_qty;
                this.form.tran_wgt = res.data.tran_wgt;
                this.form.balprc_qty = res.data.balprc_qty;
                this.form.balqty_wgt = res.data.balprc_wgt;
                this.form.sumamt = res.data.sumamt;
                this.form.sumamt2 = res.data.sumamt2;
                this.$forceUpdate();
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '155'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        // refreshs() {
        //     this.$forceUpdate();
        // },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 列表出现新增
        dtlenter(row) {
            if (!this.isedit) {
                this.dtlIndex = row.$rowIndex;
            }
        },
        dtlleave() {
            this.dtlIndex = '-1';
        },
        // 新增分称管理
        adddtl() {
            this.insertEvent(-1);
            let length = this.$refs.xTable1.getTableData().fullData.length;
            if (length > 4 && length < 11) {
                this.maxHeight += 48;
            }
        },
        deldtl(scoped) {
            let length = this.$refs.xTable1.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.xTable1.remove(scoped.row);
        },
        goHistory() {
            this.$router.push({ path: '/goldsilverinHistory', query: { page: 'goldsilverin' } });
        },
        handleInput(row, field, type) {
            if (type === 'number') {
                // 只允许数字、一个小数点和一个负号
                let inputValue = row[field]
                    .replace(/[^0-9.-]/g, '') // 删除非数字、非小数点和非负号的字符
                    .replace(/(\..*)\./g, '$1'); // 只保留第一个小数点

                // 如果输入值只有一个小数点，则替换为 '0.'
                if (inputValue === '.') {
                    inputValue = '0.';
                }
                // 处理负号，确保负号只能出现在字符串的开头
                if (inputValue && inputValue[0] === '-') {
                    // 负号在开头，允许它存在
                    inputValue = '-' + inputValue.slice(1).replace(/[^0-9.]/g, ''); // 清除负号后面的非法字符
                } else {
                    // 如果没有负号或者负号不是在开头，去掉所有负号
                    inputValue = inputValue.replace(/-/g, '');
                }

                // 更新 row[field] 的值
                row[field] = inputValue;
            }
        },
        // 尝试开发table()
        jumptable(e, row, type) {
            //所有列数据
            let column = this.$refs.xTable1.getTableColumn().fullColumn;
            // 所有行数据
            var rows = this.$refs.xTable1.getTableData().fullData;
            // 根据当前行获取行下标
            var rowIndex = this.$refs.xTable1.getVTRowIndex(row);

            // 当前列
            let nowcolumn = this.$refs.xTable1.getColumnByField(type);
            // 根据当前列获取下标
            let columnIndex = this.$refs.xTable1.getColumnIndex(nowcolumn);
            // 列数据总长度
            var length = column.length;
            //问题1：回车键最后一条不需要输入的列处理
            //问题2：无法确定一个有几个需要跳过的列
            var addnum = 1; //跳过列的基本参数，每一个需要跳过的加1
            var addnumleft = 1;
            if (column[columnIndex + 1]) {
                if (column[columnIndex + 1].className == 'jump') {
                    let newColumn = column.slice(columnIndex + 1);
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnum += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {}
                }
            }
            if (column[columnIndex - 1]) {
                if (column[columnIndex - 1].className == 'jump') {
                    let newColumn = column.slice(0, columnIndex).reverse();
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnumleft += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {}
                }
            }
            // 右移;
            var jumpnum = columnIndex + addnum;
            if (column[jumpnum]) {
                var downtype = column[jumpnum].property;
            }
            // 左移
            var jumpnumleft = columnIndex - addnumleft;
            if (column[jumpnumleft]) {
                var uptype = column[jumpnumleft].property;
            }
            if (e.keyCode == '39' || e.keyCode == '13' || e.keyCode == '9') {
                if (jumpnum == length) {
                    //最后一列换行
                    if (rowIndex + 1 == rows.length) {
                        // 最后一行 先增加行在换行
                        this.adddtl();
                        rows = this.$refs.xTable1.getTableData().fullData;
                        // 换行
                        setTimeout(() => {
                            this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                        }, 100);
                    } else {
                        this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                    }
                } else {
                    let allowBreak = true;
                    rows.forEach((item, index) => {
                        if (index === rowIndex) {
                            return;
                        }
                        if (item.barcode && item.barcode === row.barcode) {
                            this.$message.error('条码号不能重复');
                            row.barcode = '';
                            allowBreak = false;
                        }
                    });
                    if (allowBreak) {
                        // 跳转到下一列
                        this.$refs.xTable1.setActiveCell(row, downtype);
                    }
                }
            }
            if (e.keyCode == '37') {
                if (jumpnumleft == 0) {
                    //向上换行换行
                    this.$refs.xTable1.setActiveRow(rows[rowIndex - 1]);
                } else {
                    // 跳转到上一列
                    this.$refs.xTable1.setActiveCell(row, uptype);
                }
            }

            // 向下移动 (keyCode == 40)
            if (e.keyCode == '40') {
                e.preventDefault(); // 阻止默认行为
                // 确保下移时在当前列，跳到下一行的相同列
                if (rowIndex + 1 < rows.length) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex + 1], nowcolumn.property);
                }
            }

            // 向上移动 (keyCode == 38)
            if (e.keyCode == '38') {
                e.preventDefault(); // 阻止默认行为
                // 确保上移时在当前列，跳到上一行的相同列
                if (rowIndex - 1 >= 0) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex - 1], nowcolumn.property);
                }
            }
        }
    }
};
</script>

<style scoped lang="scss">
.avatar {
    width: 150px;
    height: 150px;
    display: block;
}
.table1 {
    padding: 15px;
    box-sizing: border-box;
    background-color: #fff;
    margin-top: 10px;
    padding-top: 0;

    .title {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
            font-size: 16px;
            color: #000;
        }
    }
}
.table_warpper {
    display: flex;

    .table2 {
        width: 60%;
        margin-right: 15px;
    }

    .table3 {
        width: 40%;
    }
}
</style>
<style>
/* .el-dialog__wrapper {
    left: 30%;
} */
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}
.vxe-table thead {
    background-color: #ecf5ff;
}
.vxe-table {
    background: #fff;
}
.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}
.box1 .el-select {
    width: 20%;
}
.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}
.el-select {
    width: 100%;
}
.list-item1:hover {
    background-color: #f5f7fa;
}
.orderorder {
    padding-bottom: 65px;
    box-sizing: border-box;
}
.orderorder .vxe-table .vxe-body--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-footer--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 12px 0;
}
.orderorder .vxe-table--footer-wrapper.body--wrapper {
    color: red;
}
</style>
<style scoped lang="scss">
.batchBtn {
    margin-left: 5px;
    display: inline-block;
    padding: 4px 8px;
    border: 1px solid #409eff !important;
}
.footer {
    height: 88px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
    box-sizing: border-box;

    div {
        display: flex;
        p {
            width: 20%; /* 调整为百分比 */
            min-width: 80px; /* 保证在极小的屏幕上也不会过小 */
        }
        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}
.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    .centerItem {
        width: 48%;
        text-align: center;
        /deep/ .el-upload--text {
            width: 100%;
        }
        /deep/ .el-upload-dragger {
            width: 100%;
        }
    }
    .leftItem {
        width: 48%;
        height: 180px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        border-radius: 8px;
        border: 1px dashed #97a8be;
        .itemText {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    // width: 178px;
    // height: 178px;
    line-height: 178px;
    text-align: center;
}
</style>
